import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="px-12 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/b60d1f3b-f8c0-42f8-b4f1-6f9e6cdf9522.png" 
              alt="CONSTRUTORA MANUELLA LTDA Logo" 
              className="h-12 w-12 object-contain"
            />
            <span className={`font-bold text-lg transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              CONSTRUTORA MANUELLA
            </span>
          </div>

          <div className="flex items-center gap-10">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('security')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Security
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors hover:text-cyan-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="bg-black text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-900 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            Get Started
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
